import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ICKLeverantorDetail } from "../models/ckLeverantorDetail";
import { ICKLeverantorResponseDto } from "../models/ckLeverantorDto";
import { ICKLeverantorList } from "../models/ckLeverantorList";

@Injectable({
    providedIn: "root"
})
export class CKLeverantorService {
    private readonly apiClient = inject(ApiClientService);

    searchCKLeverantorTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }
        return this.apiClient.get<ITypeAheadResult[]>(`CKLeverantor/SearchForCKLeverantorTypeAhead`, false, { input: input });
    }

    searchCKLeverantor(ckLeverantorSearchParams: any): Observable<ICKLeverantorList[]> {
        return this.apiClient.post<any, ICKLeverantorList[]>("CKLeverantor/SearchForCKLeverantor", ckLeverantorSearchParams, false, this.getHeader());
    }

    getCkLeverantorById(id: number): Observable<ICKLeverantorDetail> {
        return this.apiClient.get<ICKLeverantorDetail>(`CKLeverantor/GetCKLeverantorById/${id}`, false);
    }

    getCkLeverantorer(): Observable<ICKLeverantorResponseDto> {
        return this.apiClient.get<ICKLeverantorResponseDto>("CKLeverantor", false);
    }

    private getHeader(): HttpHeaders {
        const headers = new HttpHeaders();
        return headers.append("content-type", "application/json");
    }
}
